<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img"><img src="/assets/product/engine/4G15M/4G15M.jpg" alt=""></div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">4G15M 1.5T气道喷射增压发动机</div>
                <div class="detail-banner-desc">
                    4G15M是一款1.5T气道喷射增压发动机，最大马力143匹。该机型当量空燃比区域宽广。
                </div>
            </div>
        </div>
    </div>

    <div class="detail-box">
        <div class="detail-title">强动力</div>
        <div class="detail-desc">最大扭矩起始转速低、持续转速范围广，加速平顺、动力充足，提升行驶质感。</div>
        <div class="detail-utils">
            <div class="detail-utils-item">
                <div class="detail-utils-d">最大功率（5600-6000r/min）</div>
                <div class="detail-utils-u">105kW</div>
            </div>
            <div class="detail-utils-item">
                <div class="detail-utils-d">最大扭矩（1800～4400r/min）</div>
                <div class="detail-utils-u">210N·m</div>
            </div>
            <div class="detail-utils-item">
                <div class="detail-utils-d">低速扭矩</div>
                <div class="detail-utils-u">1000r/min 119N·m，1200r/min 131N·m</div>
            </div>
            <div class="detail-utils-item">
                <div class="detail-utils-d">排放水平</div>
                <div class="detail-utils-u">国6b</div>
            </div>
        </div>

        <div class="detail-swiper-list detail-box">
            <div class="img-box detail-swiper-right ">
                <img src="/assets/product/engine/4G15M/4G15M-1.jpg" alt=""></img>
            </div>
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        电控废气涡轮增压器
                    </div>
                    <div class="detail-desc">
                        品质可靠，性能出色。<br />增压器反应更灵敏，整车驾驶更舒适。
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="detail-box">
        <div class="detail-title">低油耗</div>
        <div class="detail-desc">全新设计燃烧系统，采用高滚流比气道、更高压缩比、多孔喷油器、缸盖集成排气歧管技术，连续可变正时气门技术，双顶置凸轮轴设计，使发动机燃烧更充分，油耗更低。</div>
        <div class="detail-four-list">
            <div class="detail-four-item">
                <div class="img-box">
                    <img src="/assets/product/engine/4G15M/4G15M-2.jpg" alt=""></img>
                </div>
            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">
                    燃烧系统优化
                </div>
                <div class="detail-four-desc">
                    采用高滚流比气道、更高的压缩比同时缸盖集成排气管，提升发动机吸气时湍动能能力及换气效率，有利于气体混合，使发动机燃烧更充分，提升发动机热效率，满足国六排放的同时更进一步降低油耗。
                </div>
            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">
                    6bar燃油喷射系统+8孔喷油器
                </div>
                <div class="detail-four-desc">
                    改善发动机喷雾及燃烧效果，发动机燃烧更充分，油耗更低。
                </div>

            </div>
            <div class="detail-four-item">
                <div class="img-box">
                    <img src="/assets/product/engine/4G15M/4G15M-3.jpg" alt=""></img>
                </div>
            </div>
        </div>
    </div>


    <div class="detail-box">
        <div class="detail-title">NVH</div>
        <div class="detail-desc">发动机NVH声品质进行提升，对发动机零部件进行静音优化，使发动机声音更“美好”。</div>
        <div class="detail-four-list">
            <div class="detail-four-item">
                <div class="img-box">
                    <img src="/assets/product/engine/4G15M/4G15M-4.jpg" alt=""></img>
                </div>
            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">
                    静音齿形链结构
                </div>
                <div class="detail-four-desc">
                    采用静音齿形链结构，降低正时链条啮合激励噪音，阶次噪音最高降低8dB(A)，提升发动机NVH水平。
                </div>

            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">
                    塑料进气歧管
                </div>
                <div class="detail-four-desc">
                    进气歧管选用塑料材料，降低发动机噪声，进一步提升发动机NVH水平。
                </div>

            </div>
            <div class="detail-four-item">
                <div class="img-box">
                    <img src="/assets/product/engine/4G15M/4G15M-5.jpg" alt=""></img>
                </div>
            </div>
        </div>
    </div>


    <div class="detail-swiper-list detail-box">
        <div class="img-box detail-swiper-right ">
            <img src="/assets/product/engine/4G15M/4G15M-6.jpg" alt=""></img>
        </div>
        <div class="detail-swiper-left">
            <div>
                <div class="detail-title">
                    凸轮轴型线优化
                </div>
                <div class="detail-desc">
                    对凸轮轴型线进行优化，降低发动机配气机构噪声，提升发动机降噪水平。
                </div>
            </div>
        </div>
    </div>



    <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
    nextTick(() => {
        const swiperContainers = document.querySelectorAll('.swiper-container');

        swiperContainers.forEach((container, index) => {
            const containerKey = `swiper_${index}`;
            container.dataset.swiperKey = containerKey;
            const swiperInstance = new Swiper(container, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 300,
                preventClicks: true,
                effect: 'fade',
            });
            swiperInstances.value[containerKey] = swiperInstance;
        });

        bindTabClickEvent();
    });
});
function bindTabClickEvent() {
    const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

    allSwiperLists.forEach((swiperList) => {
        const tabItems = swiperList.querySelectorAll('.detail-tab-item');
        const targetSwiperContainer = swiperList.querySelector('.swiper-container');

        if (!tabItems.length || !targetSwiperContainer) return;

        const containerKey = targetSwiperContainer.dataset.swiperKey;
        const targetSwiper = swiperInstances.value[containerKey];
        if (!targetSwiper) return;

        const handleTabAction = (tabItem, localTabIndex) => {
            tabItems.forEach(item => item.classList.remove('active'));
            tabItem.classList.add('active');
            targetSwiper.slideTo(localTabIndex, 300, true);
        };
        tabItems.forEach((tabItem, localTabIndex) => {
            const handleTabClickWrapper = () => {
                handleTabAction(tabItem, localTabIndex);
            };
            tabItem.removeEventListener('click', handleTabClickWrapper);
            tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
            tabItem.addEventListener('click', handleTabClickWrapper);
            tabItem.addEventListener('mouseenter', handleTabClickWrapper);
        });
    });
}

</script>

<script>
export const pageConfig = {
    title: '4G15M 1.5T气道喷射发动机 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'engine/4G15M.html'
};

import { createApp } from 'vue';
import App from './4G15M.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./4G15M.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>